import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { MigrationControllerApi } from "../services";
import {
  DGT_Pagination,
  getConfigObject,
  useBaseContent,
} from "../utils/utils";
import { GridSortItem } from "@mui/x-data-grid";
import { useEncounterCreationGate } from "../hooks/use-encounter-creation-gate";

interface UseGetDataImportProps {
  dataImportUuid: string;
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  xTENANTID?: string;
  searchString?: string;
  enabled: boolean;
}

/**
 * @author Shrinivas Mandhare
 */
const useMedicalCodesImportList = ({
  pagination,
  gridSorting,
  xTENANTID,
  dataImportUuid,
  enabled,
  searchString,
}: UseGetDataImportProps): useBaseContent<any> => {
  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "name" : undefined;
  const skip = useEncounterCreationGate();

  return useQuery({
    enabled: enabled && !skip,
    queryKey: [
      "data-import-medical-codes",
      pagination,
      dataImportUuid,
      xTENANTID,
      gridSorting,
      searchString,
    ],
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new MigrationControllerApi(getConfigObject())
        .getImportedMedicalDataData(
          dataImportUuid,
          pagination.page,
          pagination.pageSize,
          sortBy, // sortBy
          sortDirect, // sortDirection
          searchString,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};

export default useMedicalCodesImportList;
